export default "__VITE_ASSET__BGQ51nGj__"